import { createSelector, MemoizedSelector } from '@ngrx/store';
import { ProductBonus } from '@product/const';
import { StateUtils } from '@spartacus/core';
import { ProductState, StateWithProduct } from '../product-state';
import { getCustomProductState } from './feature.selector';

type BonusesState = ProductState['bonuses'];

const getBonusesEntityState: MemoizedSelector<StateWithProduct, BonusesState> = createSelector(
  getCustomProductState,
  (state: ProductState) => state.bonuses,
);

export const getBonusesState = (
  code: string,
): MemoizedSelector<StateWithProduct, StateUtils.LoaderState<ProductBonus[]>> =>
  createSelector(getBonusesEntityState, (state) => StateUtils.entitySelector(state, code));

export const getBonusesValue = (code: string): MemoizedSelector<StateWithProduct, ProductBonus[]> =>
  createSelector(getBonusesEntityState, (state) => StateUtils.entityValueSelector(state, code));

export const getBonusesLoading = (code: string): MemoizedSelector<StateWithProduct, boolean> =>
  createSelector(getBonusesEntityState, (state) => StateUtils.entityLoadingSelector(state, code));

export const getBonusesSuccess = (code: string): MemoizedSelector<StateWithProduct, boolean> =>
  createSelector(getBonusesEntityState, (state) => StateUtils.entitySuccessSelector(state, code));

export const getBonusesError = (code: string): MemoizedSelector<StateWithProduct, boolean> =>
  createSelector(getBonusesEntityState, (state) => StateUtils.entityErrorSelector(state, code));
